import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const AboutUs = Loadable(lazy(() => import('./AboutUs')));
const Carrier = Loadable(lazy(() => import('./Carrier')));
const TermsConditions = Loadable(lazy(() => import('./TermConditions')));
const UserAgreement = Loadable(lazy(() => import('./UserAgreement')));
const PrivacyPolicy = Loadable(lazy(() => import('./PrivacyPolicy')));
const CompanyPolicy = Loadable(lazy(() => import('./CompanyPolicy')));
const Disclaimer = Loadable(lazy(() => import('./Disclaimer')));
const BaggageAllowance = Loadable(lazy(() => import('./BaggageAllowance')));
const DomesticAirlines = Loadable(lazy(() => import('./DomesticAirlines')));
const DomesticFlights = Loadable(lazy(() => import('./DomesticFlights')));
const AirportIndia = Loadable(lazy(() => import('./AirportIndia')));
const DomesticBusRoutes = Loadable(lazy(() => import('./DomesticBusRoutes')));
const InternationalHotels = Loadable(
	lazy(() => import('./InternationalHotels')),
);
const InternationalFlights = Loadable(
	lazy(() => import('./InternationalFlights')),
);
const InternationalAirport = Loadable(
	lazy(() => import('./InternationalAirport')),
);
const CancellationRefundPolicy = Loadable(
	lazy(() => import('./CancellationRefundPolicy')),
);

const AboutRoutes = [
	{
		path: '/aboutus',
		element: <AboutUs />,
		auth: authRoles.admin,
	},
	{
		path: '/careers',
		element: <Carrier />,
		auth: authRoles.admin,
	},
	{
		path: '/termsconditions',
		element: <TermsConditions />,
		auth: authRoles.admin,
	},
	{
		path: '/useragreement',
		element: <UserAgreement />,
		auth: authRoles.admin,
	},
	{
		path: '/privacy-policy',
		element: <PrivacyPolicy />,
		auth: authRoles.admin,
	},
	{
		path: '/company-policy',
		element: <CompanyPolicy />,
		auth: authRoles.admin,
	},
	{
		path: '/disclaimer',
		element: <Disclaimer />,
		auth: authRoles.admin,
	},
	{
		path: '/baggage-allowance',
		element: <BaggageAllowance />,
		auth: authRoles.admin,
	},
	{
		path: '/cancellation-refund-policy',
		element: <CancellationRefundPolicy />,
		auth: authRoles.admin,
	},
	{
		path: '/international-airports',
		element: <InternationalAirport />,
		auth: authRoles.admin,
	},
	{
		path: '/domestic-airlines',
		element: <DomesticAirlines />,
		auth: authRoles.admin,
	},
	{
		path: '/domestic-flights',
		element: <DomesticFlights />,
		auth: authRoles.admin,
	},
	{
		path: '/international-flights',
		element: <InternationalFlights />,
		auth: authRoles.admin,
	},
	{
		path: '/airports-india',
		element: <AirportIndia />,
		auth: authRoles.admin,
	},
	{
		path: '/domestic-bus-routes',
		element: <DomesticBusRoutes />,
		auth: authRoles.admin,
	},
	{
		path: '/international-hotels',
		element: <InternationalHotels />,
		auth: authRoles.admin,
	},
];

export default AboutRoutes;
